/**
 * Reusable brand name component. Reads the institute name from the
 * per-deployment env var so white-label replicas don't need a rebuild.
 */
export default function BrandName({ className = "" }) {
    return (
        <span className={className}>
            {import.meta.env.VITE_INSTITUTE_NAME || "Rise Institute"}
        </span>
    );
}
